<div class="image-uploader-editor">
  @if (!files.length && !currentFile && !currentImageUrl) {
    <glxy-image-uploader
      [maxFiles]="1"
      [uploadUrl]="uploadUrl"
      [maxDimensions]="maxDimensions"
      (filesChanged)="onFilesChanged($event)"
    ></glxy-image-uploader>
  }
  @if (files.length && !currentFile && !currentImageUrl) {
    <glxy-image-upload-tile
      [url]="currentImageUrl"
      [file]="files[0]?.data?.croppedImage || files[0].file"
      [status]="files[0].status"
      [showDeleteButton]="true"
      [showEditButton]="!currentImageUrl"
      (delete)="deleteImage()"
      (edit)="editImage(files[0])"
    ></glxy-image-upload-tile>
    @if (showUploadButton) {
      <button
        mat-raised-button
        [color]="'primary'"
        (click)="uploadFiles()"
        >
        Upload
      </button>
    }
  }
  @if (!files.length && !currentFile && !!currentImageUrl) {
    <glxy-image-upload-tile
      [url]="currentImageUrl"
      [showDeleteButton]="true"
      [status]="2"
      (delete)="deleteImage()"
    ></glxy-image-upload-tile>
  }
  @if (currentFile) {
    <glxy-image-editor
      [fileInfo]="currentFile"
      [aspectRatios]="aspects"
      [maxEditorHeight]="maxEditorHeight"
      (closed)="endEdit($event)"
    ></glxy-image-editor>
  }
</div>
